// This is the Laura entry point file.
// There should be no custom code written directly in this file.

import './laura.main.css';
import './utils/accordion';
import './utils/localization';
import './utils/local-price-format';
import './utils/loyalty-service';
import './utils/lazy-image';
import './utils/kustomer-loader';
import './cart/cart-label-global'; // Initialize cart label global functions
import Global from './utils/global';
import initCartSync from './cart-sync';

window.STOREFRONT = 'LC';

// Load any global js functionality
Global();
initCartSync();

function updateStoreText() {
  const locale = Shopify?.locale || 'en';

  const tryUpdate = () => {
    const elements = document.querySelectorAll(
      'div.onelaura-store-availablefits',
    );

    elements.forEach((el) => {
      const originalText = el.textContent.trim();
      let newText = null;

      if (originalText === 'Laura, Petite, Plus') {
        newText =
          locale === 'fr' ? "Jusqu'à la taille 24/3X" : 'Up to Size 24/3X';
      } else if (originalText === 'Laura, Petite' || originalText === 'Laura') {
        newText =
          locale === 'fr' ? "Jusqu'à la taille 18/XXL" : 'Up to Size 18/XXL';
      } else if (originalText === 'Plus') {
        newText =
          locale === 'fr' ? 'Taille 14/X à 24/3X' : 'Size 14/X to 24/3X';
      }

      if (newText) {
        el.childNodes.forEach((node) => {
          const isTextNode = node.nodeType === Node.TEXT_NODE;
          const isMatch = node.textContent.trim() === originalText;

          if (isTextNode && isMatch) {
            // eslint-disable-next-line no-param-reassign
            node.textContent = newText;
          }
        });
      }
    });
  };

  // Run once in case content is already loaded
  tryUpdate();

  // Watch for changes in case content is injected dynamically
  const observer = new MutationObserver(() => {
    tryUpdate();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

updateStoreText();
